// CeilingLightPane
import React from "react";
import { num } from "../../../helpers/rooms.helpers";

const LIGHT_TYPES = [
    { value: "chandelier", label: "Люстра" },
    { value: "accent", label: "Акцентный свет" },
    { value: "spots", label: "Точечный (встраиваемый)" },
    { value: "track", label: "Трековый" },
    { value: "linear", label: "Линейный" },
    { value: "ledstrip", label: "LED лента" },
];

export default function CeilingLightPane({ title, items, onAdd, onChange, onRemove }) {
    const list = Array.isArray(items) ? items : [];

    return (
        <div className="smeta-rooms__electric-col">
            <div className="smeta-rooms__pane-head">
                <div className="smeta-rooms__sub-title-sm">{title}</div>
                <button
                    type="button"
                    className="smeta-rooms__btn smeta-rooms__btn--small"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (typeof onAdd === "function") onAdd();
                    }}
                >
                    + Добавить
                </button>
            </div>

            {list.map((p, pi) => (
                <div key={p.id || pi} className="smeta-rooms__row smeta-rooms__row--point">
                    <select
                        className="smeta-rooms__select"
                        value={String(p.type || "chandelier")}
                        onChange={(e) => onChange(pi, { type: e.target.value })}
                    >
                        {LIGHT_TYPES.map((x) => (
                            <option key={x.value} value={x.value}>
                                {x.label}
                            </option>
                        ))}
                    </select>

                    <input
                        className="smeta-rooms__input"
                        value={p.label || ""}
                        onChange={(e) => onChange(pi, { label: e.target.value })}
                        placeholder="Подпись/зона (опц.)"
                    />

                    <input
                        className="smeta-rooms__input smeta-rooms__input--sm"
                        value={p.qty ?? ""}
                        onChange={(e) => onChange(pi, { qty: num(e.target.value) })}
                        inputMode="numeric"
                        placeholder="шт"
                    />

                    <button
                        type="button"
                        className="smeta-rooms__btn smeta-rooms__btn--tiny smeta-rooms__btn--danger"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onRemove(pi);
                        }}
                    >
                        x
                    </button>
                </div>
            ))}
        </div>
    );
}
